module.exports = __webpack_public_path__ + "static/Delivery-Experiences-2691729a15396aa7a6268cb49544b7f7.jpg";